// Match image downloads to the selected one/two/four-column layout.
const observed = new WeakSet();
const resize = new ResizeObserver(entries => {
  for (const entry of entries) {
    const width = Math.ceil(entry.contentRect.width);
    if (width > 0) {
      entry.target.querySelectorAll('img.product-media__image').forEach(image => {
        const sizes = `${width}px`;
        if (image.sizes !== sizes) image.sizes = sizes;
      });
    }
  }
});
function observeCards() {
  document.querySelectorAll('results-list .card-gallery').forEach(card => {
    if (!observed.has(card)) {
      observed.add(card);
      resize.observe(card);
    }
  });
}
observeCards();
document.querySelectorAll('results-list').forEach(list => {
  new MutationObserver(observeCards).observe(list, { childList: true, subtree: true });
});
